export default __webpack_public_path__ + "static/media/woo-commerce.a6f8909d.png";